<template>
  <PersonalLayout>
    <template v-slot:header>
      <AppHeader />
    </template>
    <template v-slot:side>
      <div class="side-slide active">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 7L12 3L4 7M20 7L12 11M20 7V17L12 21M12 11L4 7M12 11V21M4 7V17L12 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Мои объекты') }}</span>
      </div>
      <router-link to="/my-fonts" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 7V4H20V7M9 20H15M12 4V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Мои шрифты') }}</span>
      </router-link>
      <router-link to="/my-processings" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('ИИ обработки') }}</span>
      </router-link>
      <router-link to="/personal-subscription" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 10H23" stroke="currentColor" stroke-width="2"/></svg>
        <span>{{ $t('Подписка') }}</span>
      </router-link>
      <router-link to="/personal-account" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Аккаунт') }}</span>
      </router-link>
      <router-link to="/personal-security" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Безопасность') }}</span>
      </router-link>
      <router-link v-if="isAdmin" to="/admin" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Панель администратора') }}</span>
      </router-link>
      <div class="side-slide logout-slide" @click="handleLogout">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Выйти') }}</span>
      </div>
    </template>
    <template v-slot:content>
      <div class="content-block">
        <div class="objects-header">
          <h1>{{ $t('Мои объекты') }}</h1>
          <p class="objects-description">{{ $t('Ваши загруженные элементы и избранное в одном месте') }}</p>
        </div>
      </div>

      <div v-if="loading" class="loading-state">
        <p>{{ $t('Загрузка...') }}</p>
      </div>

      <div v-else-if="mergedCategories.length === 0" class="empty-state">
        <p>{{ $t('У вас пока нет объектов') }}</p>
        <p class="empty-hint">{{ $t('Загрузите свои элементы или добавьте в избранное в редакторе') }}</p>
      </div>

      <template v-else>
        <div v-for="category in mergedCategories" :key="'cat_' + category.category_id" class="category-accordion">
          <div 
            class="accordion-header" 
            :class="{ 'expanded': expandedCategory === category.category_id }"
            @click="toggleCategory(category.category_id)"
          >
            <div class="accordion-title">
              <svg 
                class="accordion-arrow" 
                :class="{ 'rotated': expandedCategory === category.category_id }"
                width="20" height="20" viewBox="0 0 24 24" fill="none"
              >
                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <h2>{{ category.category_name }}</h2>
            </div>
           <span class="category-count">{{ category.total_count }} {{ $t('элементов') }}</span>
          </div>
          
          <transition name="accordion">
            <div v-if="expandedCategory === category.category_id" class="accordion-content">
              <div v-if="categoryLoading" class="category-loading">
                 <p>{{ $t('Загрузка...') }}</p>
              </div>
              
              <template v-else>
                <div class="objects-grid">
                  <div 
                    v-for="item in categoryItems" 
                    :key="item.itemKey" 
                    class="object-card"
                    :class="{ 'user-element-card': item.itemType === 'uploaded' }"
                  >
                    <div class="object-image">
                      <img :src="getImageUrl(item.image)" :alt="item.name" />
                      <div class="item-type-badge" :class="item.itemType">
                         {{ item.itemType === 'uploaded' ? $t('Загружено') : $t('Избранное') }}
                      </div>
                      <button 
                        class="remove-btn" 
                        @click.stop="removeItem(item)" 
                         :title="item.itemType === 'uploaded' ? $t('Удалить элемент') : $t('Убрать из избранного')"
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                    </div>
                    <div class="object-info">
                      <span class="object-name">{{ item.name }}</span>
                      <div class="object-prices">
                        <span 
                          v-if="item.itemType === 'favorite' && item.original_price !== null" 
                          class="original-price" 
                          :class="{ 'crossed': item.custom_price !== null }"
                        >
                          {{ item.original_price }} ₽
                        </span>
                        <div class="custom-price-row">
                          <label>{{ item.itemType === 'uploaded' ? $t('Цена:') : $t('Моя цена:') }}</label>
                          <input 
                            type="text" 
                            inputmode="numeric"
                            pattern="[0-9]*"
                            :value="item.itemType === 'uploaded' ? (item.price || '') : (item.custom_price !== null ? item.custom_price : '')"
                            @blur="updateItemPrice(item, $event)"
                            @keyup.enter="updateItemPrice(item, $event)"
                            @input="filterNumericInput($event)"
                            placeholder="—"
                            class="price-input"
                          />
                          <span class="currency">₽</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div v-if="hasMoreItems" class="load-more">
                  <button 
                    class="load-more-btn" 
                    @click.stop="loadMoreItems"
                    :disabled="loadingMore"
                  >
                    {{ loadingMore ? $t('Загрузка...') : $t('Показать ещё') }}
                  </button>
                </div>
              </template>
            </div>
          </transition>
        </div>
      </template>
    </template>
  </PersonalLayout>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import PersonalLayout from '@/layout/PersonalLayout.vue';
import { getFavoriteCategories, getFavoritesByCategory, removeFavorite, updateFavoritePrice } from '@/api/favorites';
import { getUserElementCategories, getUserElementsByCategory, deleteUserElement, updateUserElement } from '@/api/user-elements';
import { useToast } from 'vue-toastification';
import { locale } from '@/i18n';

const ITEMS_PER_PAGE = 20;

export default {
  name: 'PersonalObjectsPage',
  components: {
    AppHeader,
    PersonalLayout,
  },
  data() {
    return {
      favoriteCategories: [],
      userElementCategories: [],
      categoryItems: [],
      expandedCategory: null,
      loading: true,
      categoriesRequestId: 0,
      categoryLoading: false,
      loadingMore: false,
      currentOffset: 0,
      toast: null,
    };
  },
  computed: {
    interfaceLanguage() {
      return locale.value;
    },
    isAdmin() {
      return this.$store.getters['subscription/isAdmin'];
    },
    mergedCategories() {
      const categoryMap = new Map();
      
      this.userElementCategories.forEach(cat => {
        categoryMap.set(cat.category_id, {
          category_id: cat.category_id,
          category_name: cat.category_name,
          uploaded_count: parseInt(cat.items_count) || 0,
          favorite_count: 0,
          total_count: parseInt(cat.items_count) || 0
        });
      });
      
      this.favoriteCategories.forEach(cat => {
        if (categoryMap.has(cat.category_id)) {
          const existing = categoryMap.get(cat.category_id);
          existing.favorite_count = parseInt(cat.items_count) || 0;
          existing.total_count = existing.uploaded_count + existing.favorite_count;
        } else {
          categoryMap.set(cat.category_id, {
            category_id: cat.category_id,
            category_name: cat.category_name,
            uploaded_count: 0,
            favorite_count: parseInt(cat.items_count) || 0,
            total_count: parseInt(cat.items_count) || 0
          });
        }
      });
      
      return Array.from(categoryMap.values()).sort((a, b) => 
        a.category_name.localeCompare(b.category_name)
      );
    },
    hasMoreItems() {
      if (!this.expandedCategory) return false;
      const category = this.mergedCategories.find(c => c.category_id === this.expandedCategory);
      if (!category) return false;
      return this.categoryItems.length < category.total_count;
    }
  },
  created() {
    this.toast = useToast();
  },
  async mounted() {
    await this.loadAllCategories();
  },
  watch: {
    interfaceLanguage() {
      this.loadAllCategories();
    }
  },
  methods: {
    async handleLogout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    async loadAllCategories() {
      const language = this.interfaceLanguage;
      const requestId = ++this.categoriesRequestId;
      this.loading = true;
      try {
        const [favorites, userElements] = await Promise.all([
          getFavoriteCategories(),
          getUserElementCategories()
        ]);
        if (language === this.interfaceLanguage && requestId === this.categoriesRequestId) {
          this.favoriteCategories = favorites;
          this.userElementCategories = userElements;
        }
      } catch (error) {
        if (language !== this.interfaceLanguage || requestId !== this.categoriesRequestId) return;
        console.error('Error loading categories:', error);
         this.toast.error(this.$t('Ошибка загрузки категорий'));
      } finally {
        if (requestId === this.categoriesRequestId) this.loading = false;
      }
    },
    async toggleCategory(categoryId) {
      if (this.expandedCategory === categoryId) {
        this.expandedCategory = null;
        this.categoryItems = [];
        return;
      }
      
      this.expandedCategory = categoryId;
      this.currentOffset = 0;
      this.categoryItems = [];
      await this.loadCategoryItems(categoryId);
    },
    async loadCategoryItems(categoryId) {
      this.categoryLoading = true;
      try {
        const [favorites, userElements] = await Promise.all([
          getFavoritesByCategory(categoryId, 100, 0).catch(() => []),
          getUserElementsByCategory(categoryId).catch(() => [])
        ]);
        
        const favoriteItems = favorites.map(item => ({
          itemKey: 'fav_' + item.element_id,
          itemType: 'favorite',
          id: item.element_id,
          name: item.element_name,
          image: item.element_image,
          original_price: item.original_price,
          custom_price: item.custom_price,
          categoryId: categoryId
        }));
        
        const uploadedItems = userElements.map(item => ({
          itemKey: 'user_' + item.id,
          itemType: 'uploaded',
          id: item.id,
          name: item.name,
          image: item.image_url,
          price: item.price,
          categoryId: categoryId
        }));
        
        this.categoryItems = [...uploadedItems, ...favoriteItems];
        this.currentOffset = this.categoryItems.length;
      } catch (error) {
        console.error('Error loading category items:', error);
         this.toast.error(this.$t('Ошибка загрузки элементов'));
      } finally {
        this.categoryLoading = false;
      }
    },
    async loadMoreItems() {
      this.loadingMore = true;
      try {
        const items = await getFavoritesByCategory(this.expandedCategory, ITEMS_PER_PAGE, this.currentOffset);
        const newItems = items.map(item => ({
          itemKey: 'fav_' + item.element_id,
          itemType: 'favorite',
          id: item.element_id,
          name: item.element_name,
          image: item.element_image,
          original_price: item.original_price,
          custom_price: item.custom_price,
          categoryId: this.expandedCategory
        }));
        this.categoryItems = [...this.categoryItems, ...newItems];
        this.currentOffset += items.length;
      } catch (error) {
        console.error('Error loading more items:', error);
         this.toast.error(this.$t('Ошибка загрузки'));
      } finally {
        this.loadingMore = false;
      }
    },
    getImageUrl(imagePath) {
      if (!imagePath) return '';
      if (imagePath.startsWith('http')) return imagePath;
      if (imagePath.startsWith('/')) return imagePath;
      return `/${imagePath}`;
    },
    async removeItem(item) {
      if (item.itemType === 'uploaded') {
         if (!confirm(this.$t('Удалить этот элемент?'))) return;
        try {
          await deleteUserElement(item.id);
          this.categoryItems = this.categoryItems.filter(i => i.itemKey !== item.itemKey);
          
          const userCat = this.userElementCategories.find(c => c.category_id === item.categoryId);
          if (userCat) {
            userCat.items_count = parseInt(userCat.items_count) - 1;
            if (userCat.items_count <= 0) {
              this.userElementCategories = this.userElementCategories.filter(c => c.category_id !== item.categoryId);
            }
          }
          
          this.checkCategoryEmpty(item.categoryId);
           this.toast.success(this.$t('Элемент удалён'));
        } catch (error) {
          console.error('Error removing user element:', error);
           this.toast.error(this.$t('Ошибка удаления элемента'));
        }
      } else {
        try {
          await removeFavorite(item.id);
          this.categoryItems = this.categoryItems.filter(i => i.itemKey !== item.itemKey);
          
          const favCat = this.favoriteCategories.find(c => c.category_id === item.categoryId);
          if (favCat) {
            favCat.items_count = parseInt(favCat.items_count) - 1;
            if (favCat.items_count <= 0) {
              this.favoriteCategories = this.favoriteCategories.filter(c => c.category_id !== item.categoryId);
            }
          }
          
          this.checkCategoryEmpty(item.categoryId);
           this.toast.success(this.$t('Элемент убран из избранного'));
        } catch (error) {
          console.error('Error removing favorite:', error);
           this.toast.error(this.$t('Ошибка удаления из избранного'));
        }
      }
    },
    checkCategoryEmpty(categoryId) {
      const category = this.mergedCategories.find(c => c.category_id === categoryId);
      if (!category || category.total_count <= 0) {
        if (this.expandedCategory === categoryId) {
          const remaining = this.mergedCategories.filter(c => c.category_id !== categoryId);
          if (remaining.length > 0) {
            this.toggleCategory(remaining[0].category_id);
          } else {
            this.expandedCategory = null;
          }
        }
      }
    },
    filterNumericInput(event) {
      event.target.value = event.target.value.replace(/[^0-9]/g, '');
    },
    async updateItemPrice(item, event) {
      const value = event.target.value.replace(/[^0-9]/g, '');
      const newPrice = value === '' ? null : parseInt(value, 10);
      
      if (newPrice !== null && (isNaN(newPrice) || newPrice < 0)) {
         this.toast.error(this.$t('Введите корректную цену'));
        return;
      }
      
      try {
        if (item.itemType === 'uploaded') {
          await updateUserElement(item.id, { price: newPrice || 0 });
          item.price = newPrice || 0;
        } else {
          await updateFavoritePrice(item.id, newPrice);
          item.custom_price = newPrice;
        }
         this.toast.success(this.$t('Цена обновлена'));
      } catch (error) {
        console.error('Error updating price:', error);
         this.toast.error(this.$t('Ошибка обновления цены'));
      }
    }
  }
};
</script>

<style scoped>
.side-slide {
  display: block;
  padding: 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  color: #1a1a1a;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 5px;
  border: 1px solid transparent;
  text-decoration: none;
}

.side-slide p {
  margin: 0;
  color: inherit;
}

.side-slide a {
  color: inherit;
}

.side-slide.active {
  border-color: #fafafa;
  box-shadow: inset 1px 1px 2px 0 rgba(0, 0, 0, 0.09);
  color: #1a1a1a;
}

.side-slide + .side-slide {
  margin-top: 5px;
}

.objects-header {
  margin-bottom: 10px;
}

.objects-header h1 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.objects-description {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.loading-state,
.empty-state {
  text-align: center;
  padding: 40px 20px;
  background: #fff;
  border-radius: 10px;
  margin: 10px 0;
}

.loading-state p,
.empty-state p {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.empty-hint {
  font-size: 14px !important;
  color: #999 !important;
  margin-top: 10px !important;
}

.category-accordion {
  background: #fff;
  border-radius: 12px;
  margin-top: 10px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  transition: background-color 0.2s;
  user-select: none;
}

.accordion-header:hover {
  background-color: #f8f9fa;
}

.accordion-header.expanded {
  border-bottom: 1px solid #eee;
}

.accordion-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.accordion-arrow {
  color: #666;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.accordion-arrow.rotated {
  transform: rotate(90deg);
}

.accordion-header h2 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.category-count {
  font-size: 13px;
  color: #999;
  white-space: nowrap;
}

.accordion-content {
  padding: 16px 20px;
}

.category-loading {
  text-align: center;
  padding: 20px;
  color: #666;
}

.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.accordion-enter-from,
.accordion-leave-to {
  opacity: 0;
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.accordion-enter-to,
.accordion-leave-from {
  opacity: 1;
  max-height: 2000px;
}

.objects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 14px;
}

.object-card {
  background: #f8f9fa;
  border-radius: 10px;
  overflow: hidden;
  transition: box-shadow 0.2s;
  display: flex;
  flex-direction: column;
}

.object-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.user-element-card {
  border: 2px solid #e8f4ff;
}

.object-image {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
  overflow: hidden;
}

.object-image img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.item-type-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

.item-type-badge.uploaded {
  background: #e8f4ff;
  color: #3182ce;
}

.item-type-badge.favorite {
  background: #fef3c7;
  color: #d97706;
}

.remove-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: none;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s, background 0.2s;
  color: #666;
}

.object-card:hover .remove-btn {
  opacity: 1;
}

.remove-btn:hover {
  background: #fee;
  color: #e53e3e;
}

.object-info {
  padding: 12px;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.object-name {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.object-prices {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.original-price {
  font-size: 13px;
  color: #666;
}

.original-price.crossed {
  text-decoration: line-through;
  color: #999;
  font-size: 12px;
}

.custom-price-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.custom-price-row label {
  font-size: 11px;
  color: #666;
  white-space: nowrap;
}

.price-input {
  width: 80px;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
  -moz-appearance: textfield;
}

.price-input::-webkit-outer-spin-button,
.price-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.price-input:focus {
  outline: none;
  border-color: #3182ce;
}

.currency {
  font-size: 12px;
  color: #666;
}

.load-more {
  margin-top: 20px;
  text-align: center;
}

.load-more-btn {
  padding: 10px 24px;
  background: #f0f0f0;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: background 0.2s;
}

.load-more-btn:hover:not(:disabled) {
  background: #e0e0e0;
}

.load-more-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .objects-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  
  .object-card .remove-btn {
    opacity: 1;
  }
  
  .item-type-badge {
    font-size: 9px;
    padding: 2px 6px;
  }
}
</style>
